export const SMS_ENCODING = {
  GSM: 'GSM-7',
  UNICODE: 'UCS-2'
} as const;

export const SEGMENT_SIZE = {
  GSM: 160,
  UNICODE: 70
} as const;

export const BITS_PER_CHAR = {
  GSM: 7,
  UNICODE: 16
} as const;

export const DEFAULT_METRICS = {
  charactersLeft: SEGMENT_SIZE.GSM,
  totalSegments: 1,
  encoding: 'GSM' as const,
  segmentSize: SEGMENT_SIZE.GSM,
  usedCharacters: 0
};

/**
 * MMS Constants
 * These values are based on carrier and industry standards.
 * DO NOT modify without careful consideration of carrier requirements.
 */
export const MMS_CONSTANTS = {
  /** Maximum file size in bytes (500KB) */
  MAX_FILE_SIZE: 500 * 1024,
  /** Supported file types for MMS images */
  SUPPORTED_FILE_TYPES: ['image/jpeg', 'image/png', 'image/gif'] as const,
  /** File size display in KB */
  MAX_FILE_SIZE_DISPLAY: '500KB'
} as const;

/**
 * Error Messages
 * Centralized error messages for consistency
 */
export const ERROR_MESSAGES = {
  FILE_TOO_LARGE: 'Please select an image under 500KB',
  INVALID_FILE_TYPE: 'Please select an image file (PNG, JPG, or GIF)'
} as const;
